<template>
  <WdsLabel
    :gray="isGrayStatus"
    :success="isSuccessStatus"
    :primary="isPrimaryStatus"
    :error="isErrorStatus"
    :subtle="isSubtleStatus"
    :data-test="dataTestId"
  >
    {{ $t(displayText) }}
  </WdsLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { HireActiveStatus } from '@/gql/graphql'
import { convertEnumToDisplayText } from '@/utils/tools'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

interface Props {
  status: HireActiveStatus
  dataTestId?: string
}

const props = withDefaults(defineProps<Props>(), {
  dataTestId: 'hire-status-label',
})

const isGrayStatus = computed(
  () => props.status === HireActiveStatus.Draft || props.status === HireActiveStatus.Cancelled,
)

const isSuccessStatus = computed(() =>
  [HireActiveStatus.Ready, HireActiveStatus.Active].includes(props.status),
)

const isPrimaryStatus = computed(() => props.status === HireActiveStatus.Offered)

const isErrorStatus = computed(() =>
  [HireActiveStatus.Ended, HireActiveStatus.Terminated].includes(props.status),
)

const isSubtleStatus = computed(
  () => props.status !== HireActiveStatus.Active && props.status !== HireActiveStatus.Draft,
)

const displayText = computed(() => convertEnumToDisplayText(props.status))
</script>
